<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pQCkzp/tc-custom/9781423651222.jpg?1718079009360" alt="This image is the cover for the book You've Totally Got This!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">You've Totally Got This!
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A beautifully designed collection of hand-lettered inspirational quotes for more than a year of Motivational Mondays.</b><br/>  <br/> Sometimes all we need is a little nudge: this book serves as inspiration for those facing new beginnings, a sudden change, or just a whole lot to do. <i>You’ve Totally Got This!</i> gives you the encouragement you need with such quotes as:<br/> ·       “The secret of getting ahead is getting started.”<br/> ·       “Keep some room in your heart for the unimaginable.” (Mary Oliver)<br/> ·       “Just say yes and you’ll figure it out afterwards.” (Tina Fey)<br/> ·       “You don’t have to see the whole staircase, just take the first step.” (Dr. Martin Luther King, Jr.)<br/> ·       “Opportunity is missed by people because it is dressed in overalls and looks like work.”<br/> ·       “I have not failed. I’ve just found 10,000 ways that won't work.” (Thomas Edison)<br/> ·       “Don't compare your beginning to someone else’s middle.” (Tim Hiller)<br/>  <br/> Great for grads, creatives, and entrepreneurs: every spread is like a greeting card, so this delightful volume serves as a stand-alone championing or as the perfect finishing touch to a gift.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frances Macleod
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ede94afc